import { GroupSecurity } from '@quromedical/fhir-common';
import { WithGroup } from 'core/auth';
import { ChatRoomCard } from 'core/chat';
import type React from 'react';

interface PatientChatTabProps {
  patientId: string;
}

export const PatientChatTab: React.FC<PatientChatTabProps> = ({
  patientId,
}) => {
  return (
    <WithGroup groups={[GroupSecurity.CommunicationCreate]}>
      <ChatRoomCard patientId={patientId} key={patientId} />
    </WithGroup>
  );
};
